export const notificationKeys = {
    all: ['notifications'] as const,
    list: (readState: string, type: string) => [...notificationKeys.all, 'list', readState, type] as const,
    allLists: () => [...notificationKeys.all, 'list'] as const,
    unreadCount: () => [...notificationKeys.all, 'unread-count'] as const,
} as const;
